// Third-Party
import React from 'react';
import classNames from 'classnames';

// Components
import Button from './Button';

type Props = {
  number: number;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  color?: string;
};

const Dot = ({ number, onClick, className, color }: Props) => (
  <Button className={classNames('dot', className, color)} onClick={onClick} type="button">
    {number}
  </Button>
);

export default Dot;
